<template>
  <b-container id="view" class="fiche_container">
    <b-row>
      <b-col>
        <b-link href="/challenge-maritima/"
          ><b-button class="back_button"><b-icon icon="arrow-left"></b-icon> Retour</b-button></b-link
        >

        <h2 class="title_section"><b-icon icon="square-fill" class="puce"></b-icon> {{ organisation.name }}</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row>
          <b-col>
            <div class="inner_stat">
              <p class="label_stat">Classement</p>
              <p class="value_stat">{{ organisation.classement }}</p>
            </div>
          </b-col>
          <b-col>
            <div class="inner_stat">
              <p class="label_stat">Points</p>
              <p class="value_stat">{{ organisation.points }}</p>
            </div>
          </b-col>
          <b-col>
            <div class="inner_stat">
              <p class="label_stat">Coureurs</p>
              <p class="value_stat">{{ organisation.nb_coureurs }}</p>
            </div>
          </b-col>
          <b-col md="12">
            <div class="inner_stat">
              <p class="label_stat">Nb Participations cumulées</p>
              <p class="value_stat">{{ organisation.nb_participations }}</p>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row style="margin: 20px 0">
      <b-col>
        <h2 class="title_section"><b-icon icon="square-fill" class="puce"></b-icon> Résultats des coureurs</h2>
      </b-col>
    </b-row>

    <div v-for="(coureur, index) in organisation.coureurs" :key="index" class="container_coureur_in_fiche_orga">
      <b-row>
        <b-col md="2" class="flex-center">
          <img class="photo_profil" :src="'https://sportips.fr/MAR23/upload/' + coureur.url_photo" />
        </b-col>
        <b-col>
          <h3 class="coureur_name"><img class="flag" :src="'https://sportips.fr/live/img/Flags/' + coureur.nation + '.jpg'" />{{ coureur.nom }} {{ coureur.prenom }}</h3>
          <p class="coureur_infos">
            <b>Sexe :</b> {{ coureur.sexe }} <span class="sep">|</span>
            <b>Catégorie :</b>
            {{ coureur.categorie }}
          </p>
          <p class="coureur_infos"><b>Club :</b> {{ coureur.club }} <span class="sep">|</span> <b>Entreprise :</b> {{ coureur.entreprise }}</p>
          <b-row>
            <b-col>
              <div class="inner_stat">
                <p class="label_stat">Classement</p>
                <p class="value_stat">{{ coureur.classement }}</p>
              </div>
            </b-col>
            <b-col>
              <div class="inner_stat">
                <p class="label_stat">Points</p>
                <p class="value_stat">{{ coureur.points }}</p>
              </div>
            </b-col>
            <b-col>
              <div class="inner_stat">
                <p class="label_stat">Courses</p>
                <p class="value_stat">{{ coureur.nb_participations }}</p>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-table style="margin-top: 20px" id="table_classement" hover small responsive :items="coureur.participations" :fields="fields">
        <template #cell(date)="data">
          {{ data.item.course.date }}
        </template>
        <template #cell(course)="data">
          <b>{{ data.item.course.name }}</b>
        </template>
        <template #cell(distance)="data">
          {{ data.item.course.distance }}
        </template>
        <template #cell(points)="data">
          <b>{{ data.item.points }}</b>
        </template>
      </b-table>
    </div>
    <p style="font-size: 12px; padding-bottom: 10px; text-align: center">
      <b>Généré par </b> <a href="https://sportips.fr" target="_blank"><img src="https://sportips.fr/ressources/logo_menu.png" style="display: inline; width: 80px" /></a>
    </p>
  </b-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      organisation: {},
      fields: [
        { key: "date", label: "Date" },
        { key: "course", label: "Course" },
        { key: "distance", label: "Distance" },
        { key: "points", label: "Points" },
        { key: "temps", label: "Temps" },
        { key: "classement_scratch", label: "Clt scratch" },
        { key: "classement_sexe", label: "Clt sexe" },
        { key: "classement_cat", label: "Clt cat" },
      ],
    };
  },
  mounted() {
    var _this = this;
    axios.get(this.$store.state.base_url + "/organisation/get.php?id=" + this.$route.params.id_organisation).then(function (response) {
      _this.organisation = response.data;
    });
  },
};
</script>

<style lang="scss" scoped></style>
